import { Archive, CalendarRemove, Copy, Edit, EmailSent, Eye, Trash } from 'seagull/icons';
export const draftRowActions = (param)=>{
    let { isScheduled, handlers, rowTexts, draftsTexts } = param;
    return [
        ...handlers.onEdit ? [
            {
                icon: Edit,
                label: rowTexts.edit(),
                onClick: handlers.onEdit,
                bi: {
                    name: 'table_list_actions_edit'
                }
            }
        ] : [],
        {
            icon: Eye,
            label: rowTexts.preview(),
            onClick: handlers.onPreview,
            bi: {
                name: 'table_list_actions_preview'
            }
        },
        ...isScheduled ? [
            {
                icon: EmailSent,
                label: draftsTexts.sendNow(),
                onClick: handlers.onSendNow,
                bi: {
                    name: 'table_list_actions_send_now'
                }
            },
            {
                icon: CalendarRemove,
                label: draftsTexts.cancelScheduling(),
                onClick: handlers.onCancelScheduling,
                bi: {
                    name: 'table_list_actions_cancel'
                }
            }
        ] : [],
        {
            icon: Copy,
            label: rowTexts.duplicate(),
            heapId: 'draft-menu-duplicate',
            onClick: handlers.onDuplicate,
            bi: {
                name: 'table_list_actions_duplicate'
            }
        },
        {
            icon: Archive,
            label: rowTexts.archive(),
            disabled: isScheduled,
            tooltip: isScheduled ? rowTexts.cancelSchedulingBeforeArchiving() : undefined,
            onClick: handlers.onArchive,
            bi: {
                name: 'archive'
            }
        },
        {
            icon: Trash,
            label: rowTexts.delete(),
            destructive: true,
            heapId: 'draft-menu-discard',
            onClick: handlers.onDelete,
            bi: {
                name: 'table_list_actions_discard'
            }
        }
    ];
};
